import {
  AuthModal,
  EULAModal,
  PrivacyPolicyModal,
  SecurityPolicyModal,
  SoftwareLicensesModal,
} from '@app-velocity/modules/users';

import { AboutModal } from './modals/AboutModal/AboutModal';
import { NewPluginVersionModal } from './modals/NewPluginVersionModal';
import { NewPluginUIVersionModal } from './modals/NewPluginUIVersionModal';
import { IncorrectFlowStructureModal } from './modals/IncorrectFlowStructureModal';
import { SavePluginModal } from './modals/SavePluginModal';

export const AppModals = () => {
  return (
    <>
      <EULAModal />
      <PrivacyPolicyModal />
      <SecurityPolicyModal />
      <SoftwareLicensesModal />
      <AboutModal />
      <NewPluginVersionModal />
      <NewPluginUIVersionModal />
      <IncorrectFlowStructureModal />
      <SavePluginModal />
      <AuthModal />
    </>
  );
};
